/* unplugin-vue-components disabled */import script from "./Position.vue?vue&type=script&lang=ts&setup=true"
export * from "./Position.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__